import { CaretRight, Star } from '@phosphor-icons/react';
import Avatar from '../../../../../shared/components/Avatar';
import { formatDate } from '../../../../../shared/utils/date';

type ReviewsListProps = {
  reviews: any[];
  t: any;
  onOpen: (place: any) => void;
};

export default function ReviewsList({ reviews, t, onOpen }: ReviewsListProps) {
  return (
    <div className="reviews-list">
      {reviews.map((review) => (
        <button key={review.id} onClick={() => onOpen(review.place)}>
          <Avatar
            size={42}
            user={{
              avatar: review.authorAvatar,
              color: review.authorColor,
              username: review.authorUsername,
            }}
          />
          <span className="review-summary">
            <b>{review.authorName || `@${review.authorUsername}`}</b>
            <small>{review.placeName}</small>
            {review.text && <p>{review.text}</p>}
          </span>
          <span className="review-meta">
            <strong><Star weight="fill" />{review.rating}</strong>
            <small>{formatDate(review.createdAt, t.locale)}</small>
          </span>
          <CaretRight />
        </button>
      ))}
    </div>
  );
}
